import { Injectable } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";

@Injectable()
export class SpanishPaginatorIntl extends MatPaginatorIntl {
  itemsPerPageLabel = "Elementos por página:";
  nextPageLabel = "Página siguiente";
  previousPageLabel = "Página anterior";
  firstPageLabel = "Primera página";
  lastPageLabel = "Última página";

  getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 de ${length}`;
    }
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} – ${endIndex} de ${length}`;
  };
}
